import Container from "features/shared/styles/container/Container.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import styled from "styled-components";

const IneligibleContainer = styled(Container)`
  height: 500px;
  max-width: 488px;
  width: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 137px;
    margin-bottom: 16px;
  }

  ${Summary} {
    white-space: pre-wrap;
    text-align: center;
    margin-top: 10px;
  }

  ${TertiaryHeader} {
    margin-bottom: 16px;
  }

  ${TertiaryHeader} + ${Summary} {
    margin-top: 0;
  }

  a {
    margin-top: 24px;
  }
`;
export default IneligibleContainer;
